import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { restoreSession } from "./store/authSlice";

/**
 * Runs once on app load. If the access token in Redux is missing/expired
 * but localStorage still has a token+user pair (see authSlice's
 * readStoredSession — it deliberately stops short of wiping those on a
 * merely-expired access token), attempts one silent refresh using the
 * refresh-token cookie before the user ever sees a login form. This is
 * what lets "closed the tab, came back an hour later" land back on the
 * dashboard instead of forcing a full re-login every time the 15-minute
 * access token has lapsed — see ProtectedRoute/PublicRoute, which only
 * ever look at Redux state and have no way to attempt this themselves.
 */
export function SessionBootstrap() {
  const dispatch = useAppDispatch();
  const token = useAppSelector((state) => state.auth.token);
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current || token) return;
    attempted.current = true;
    dispatch(restoreSession());
  }, [dispatch, token]);

  return null;
}
